import { z } from "zod";
import { common } from "../common";
import { conversionGetBaseSchema } from "./conversionGetBaseSchema";

export const usedAppConversionGetSchema = z.object({
  ...conversionGetBaseSchema.shape,
  event_type: z.literal("TrackedUserBehavior::UsedApp"),
  app_ids: z.array(common.objectId).nullable(),
  type: z.literal("open"),
});
